import React from 'react';
import { fmtNumber } from '../kit';

/**
 * The round blue count beside a card's title ("People 4", "Requests 12"). One component
 * so every card's badge has the same size, colour and weight.
 *
 * @param {object} props
 * @param {number} props.count
 * @param {boolean} [props.more]   More exist than were loaded: reads "50+" and the label says "or more".
 * @param {string} props.noun      What is counted, singular ("request"); the plural adds an "s"
 *   unless `plural` is given.
 * @param {string} [props.plural]  Irregular plural ("people").
 * @param {string} [props.testId]
 * @param {string} [props.className]
 */
export default function CountBadge({ count, more = false, noun, plural, testId, className = '' }) {
  const words = count === 1 && !more ? noun : (plural || `${noun}s`);
  return (
    <span
      data-testid={testId}
      aria-label={`${fmtNumber(count)}${more ? ' or more' : ''} ${words}`}
      className={`flex h-6 min-w-6 items-center justify-center rounded-full bg-brand px-1.5 text-sm font-semibold text-gray-950 ${className}`.trim()}
    >
      {fmtNumber(count)}{more ? '+' : ''}
    </span>
  );
}
